import { createApp } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Navigation, Pagination, Scrollbar, FreeMode, Thumbs, Grid } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import "swiper/css/grid"
import { Modal } from "bootstrap"

const app = createApp({
    components: {
        Swiper,
        SwiperSlide,
        Modal,
    },
    setup() {
        /**
         * Altera o hash para a seção ativa
         */
        return {
            Navigation,
            Pagination,
            Scrollbar,
            FreeMode,
            Thumbs,
            Grid,
        }
    },
    data() {
        return {
            toggleAboutText: false,
            toggleHours: false,
            toggleGallery: true,
            modal: null,
            modalElement: null,
            catalog: {
                url: null,
                filename: null,
                isImage: false,
                isPdf: false,
            },
            swiperOptions: {
                tabs: {},
                offers: {
                    ref: null,
                    slidesOffsetAfter: 12,
                    breakpoints: {
                        0: {
                            slidesPerView: 1.2,
                            grid: { rows: 2, fill: "row" },
                        },
                        480: {
                            slidesPerView: 1.5,
                            grid: { rows: 2, fill: "row" },
                        },
                        640: {
                            slidesPerView: 1.8,
                            grid: { rows: 2, fill: "row" },
                        },
                        1024: {
                            slidesPerView: 3,
                            grid: { rows: 2, fill: "row" },
                        },
                        1280: {
                            slidesPerView: 3,
                            grid: { rows: 2, fill: "row" },
                        },
                    },
                },
            },
            gallery: {
                visible: false,
                currentIndex: 0,
                totalItems: 0,
                mainGallery: null,
                thumbGallery: null,
            },
            mapa: {
                nome: null,
                latitude: null,
                longitude: null,
                referencia: null,
                endereco: null,
            },
        }
    },
    mounted() {
        this.modalElement = document.getElementById("galeriaModal")

        if (this.modalElement) {
            this.modal = new Modal(this.modalElement)

            this.modalElement.addEventListener("hidden.bs.modal", () => {
                this.gallery.visible = false

                //this.stopVideo()
            })
        }

        const catalogModalElement = document.getElementById("catalogModal")

        if (catalogModalElement) {
            catalogModalElement.addEventListener("hidden.bs.modal", () => {
                this.catalog = {
                    url: null,
                    filename: null,
                    isImage: false,
                    isPdf: false,
                }
            })
        }
    },
    methods: {
        openGallery(index, video = false) {
            if (!this.modal) {
                return
            }

            console.log("index:", index)
            this.gallery.visible = true
            this.gallery.currentIndex = index

            this.modal.show()
            
            this.$nextTick(() => {
                if (this.gallery.mainGallery) {
                    this.gallery.mainGallery.slideTo(index, 0)
                }

                /*if (video) {
                    const iframe = document.querySelector(
                        ".company-video.full iframe"
                    )

                    if (iframe && iframe.getAttribute("data-src")) {
                        iframe.setAttribute(
                            "src",
                            iframe.getAttribute("data-src") + "?autoplay=1"
                        )
                    }
                }*/
            })
        },
        onGallerySlideChange(event) {
            this.gallery.totalItems = event.slides.length
            this.gallery.currentIndex = event.activeIndex

            this.$nextTick(() => {
                this.gallery.thumbGallery?.slideTo(event.activeIndex)
            })
        },
        setMainGallerySwiper(swiper) {
            this.gallery.mainGallery = swiper
        },
        setThumbGallerySwiper(swiper) {
            this.gallery.thumbGallery = swiper
        },
        galleryNext() {
            this.gallery.mainGallery?.slideNext()
        },
        galleryPrev() {
            this.gallery.mainGallery?.slidePrev()
        },
        offersLoad(swiper) {
            this.swiperOptions.offers.ref = swiper
        },
        offersNext() {
            this.swiperOptions.offers.ref?.slideNext()
        },
        offersPrev() {
            this.swiperOptions.offers.ref?.slidePrev()
        },
        openMaps(empresa) {
            this.mapa = empresa
            const modal = new Modal(document.getElementById("mapsModal"))
            modal.show()
        },
        openCatalog(url, filename) {
            const extension = (filename?.split(".").pop() || "").toLowerCase()
            const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "svg"]
            const isImage = imageExtensions.includes(extension)
            const isPdf = extension === "pdf"

            this.catalog = {
                url,
                filename,
                isImage,
                isPdf,
            }

            const modalElement = document.getElementById("catalogModal")

            if (!modalElement) {
                return
            }

            const modal = new Modal(modalElement)
            modal.show()
        },
        stopVideo(n) {
            const iframe = document.querySelector(".company-video.full iframe")

            if (iframe) iframe.setAttribute("src", null)
        },
        openPhonesModal() {
            const modal = new Modal(document.getElementById("phonesModal"))
            modal.show()
        },
    },
    watch: {},
})

app.mount("#company-page")
